import * as React from 'react';
import styled from 'styled-components';
import {
  color,
  ColorProps,
  compose,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';

export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.236 9.35l2.498-2.666a.997.997 0 000-1.372l-2.498-2.666a1 1 0 00-1.46 1.368l.925.986H7.027C5.702 5 4.46 5.654 3.57 6.545c-.89.89-1.543 2.132-1.543 3.457v.568a1 1 0 102 0v-.568c0-.675.347-1.433.957-2.043.61-.61 1.368-.958 2.043-.96h9.67l-.922.983a1 1 0 001.46 1.368zm4.739 9.568c.36 0 .624.072.792.216.168.144.252.36.252.648 0 .592-.348.888-1.044.888H17.81c-.696 0-1.044-.296-1.044-.888 0-.288.084-.504.252-.648.168-.144.432-.216.792-.216h.972v-4.332l-.96.564a.818.818 0 01-.42.12c-.224 0-.416-.096-.576-.288-.16-.2-.24-.42-.24-.66 0-.328.14-.576.42-.744l1.92-1.116c.352-.2.684-.3.996-.3.32 0 .576.096.768.288.2.192.3.452.3.78v5.688h.984zm-8.946-1.916a1 1 0 110 2H6.907l.923.984a1 1 0 11-1.46 1.368l-2.498-2.666a.996.996 0 010-1.372L6.37 14.65a1 1 0 011.459 1.368l-.923.984h6.122z"
        clipRule="evenodd"
      />
    </svg>
  );
});
export const IconSystemV2MediaRepeat1Time = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
